import React from 'react'
import * as Fields from 'support/fields'
import {
  ForEachModel,
  useValue,
  ValueToCollection,
  WhenCollectionIsEmpty,
  WhenCollectionIsNotEmpty
} from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import { Translation } from '@morningtrain/react-translations'
import { FieldWrapper } from '@morningtrain/react-fields'

export default function StepFields ({
  isCompleted = false
}) {
  const stepId = useValue('id')

  if (isCompleted === true) {
    return (
      <>
        <FieldWrapper
          label={<Translation name='fields.comment.label' />}
        >
          <Displays.Html name='comment' defaultValue='-' />
        </FieldWrapper>
        <FieldWrapper
          label={<Translation name='fields.files.label' />}
        >
          <ValueToCollection name='files'>
            <WhenCollectionIsEmpty>
              <span>
                <Translation name='fields.files.no_files' />
              </span>
            </WhenCollectionIsEmpty>
            <WhenCollectionIsNotEmpty>
              <ul>
                <ForEachModel>
                  <li>
                    <Displays.Link name='url'>
                      <Displays.Text name='name' />
                    </Displays.Link>
                  </li>
                </ForEachModel>
              </ul>
            </WhenCollectionIsNotEmpty>
          </ValueToCollection>
        </FieldWrapper>
      </>
    )
  }

  return (
    <>
      <Fields.Hidden
        fromName='id'
        name={`steps[${stepId}][id]`}
      />
      <Fields.TextArea
        fromName='comment'
        name={`steps[${stepId}][comment]`}
        label={<Translation name='fields.comment.label' />}
      />
      <Fields.File
        fromName='files'
        name={`steps[${stepId}][files][]`}
        label={<Translation name='fields.files.label' />}
        multiple
      >
        <ValueToCollection name='files'>
          <ul>
            <ForEachModel>
              <li>
                <Displays.Link name='url'>
                  <Displays.Text name='name' />
                </Displays.Link>
              </li>
            </ForEachModel>
          </ul>
        </ValueToCollection>
      </Fields.File>
    </>
  )
}
